module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10223.94c29c83.jpg";